module.exports = __webpack_public_path__ + "media/images/clearbanc-ventures-logo-385fe106dd8ceffa478067b2560e8cc9.svg";